import styled from "styled-components";

export const DetailCard = styled.div`
  background: var(--lightest);
  border: 1px solid var(--gray-light);
  border-radius: 12px;
  padding: 32px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);

  body.high-contrast & {
    background: #000 !important;
    border-color: #ffff00 !important;
  }

  @media (max-width: 768px) {
    padding: 20px;
  }
`;

export const DetailFieldLabel = styled.span`
  display: block;
  font-size: 0.75rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--neutral-light);
  margin-bottom: 4px;
`;

export const DetailFieldValue = styled.span`
  display: block;
  font-size: 1rem;
  color: var(--neutral);
  line-height: 1.5;
`;

export const DetailSectionTitle = styled.h3`
  font-size: 0.875rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  color: var(--primary);
  margin: 8px 0 4px 0;
  padding-bottom: 8px;
  border-bottom: 2px solid var(--gray-light);
`;
